<template>
    <div class="container">
        <div class="main__top">
            <h1 class="main__title wow fadeInDown" data-wow-duration="1.5s">users</h1>
            <ul class="main__breadcrumbs wow zoomIn" data-wow-duration="1.5s">
                <li><a href="/admin/users">Users</a></li>
                <li>Add New</li>
            </ul>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-11">
                <div class="login mt-0 wow zoomIn" data-wow-duration="1.5s">
                    <div class="form">
                        <ValidationObserver ref="form">
                            <span class="login__sub-title text-left mb-2">USER</span>
                            <div class="row justify-content-center">

                                <CoverUploader
                                    class="mb-4"
                                    :component-name="`user`"
                                    :file="avatarFile"
                                    @update-cover="updateUserAvatar"
                                />

                                <div class="col-md-10">
                                    <div class="row mb-3">
                                        <ValidationProvider
                                            class="col-sm-6"
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="First Name"
                                        >
                                            <label class="form-group">
                                                <span class="form-label">First Name*</span>
                                                <input type="text" class="form-control" v-model="form.first_name">
                                                <FormError :error="errors[0]"  name="First Name"></FormError>
                                            </label>
                                        </ValidationProvider>

                                        <ValidationProvider
                                            class="col-sm-6"
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="Last Name"
                                        >
                                            <label class="form-group">
                                                <span class="form-label">Last Name*</span>
                                                <input type="text" class="form-control" v-model="form.last_name">
                                                <FormError :error="errors[0]"  name="Last Name"></FormError>
                                            </label>
                                        </ValidationProvider>

                                        <ValidationProvider
                                            class="col-sm-6"
                                            name="Email"
                                            v-slot="{ errors }"
                                            rules="required|email"
                                        >
                                            <label class="form-group">
                                                <span class="form-label">Email*</span>
                                                <input type="email" class="form-control" v-model="form.email">
                                                <FormError :error="errors[0]"  name="Email"></FormError>
                                            </label>
                                        </ValidationProvider>

                                        <ValidationProvider
                                            class="col-sm-6"
                                            name="Phone"
                                            v-slot="{ errors }"
                                            rules="required"
                                        >
                                            <label class="form-group">
                                                <span class="form-label">Phone Number*</span>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-mask="'+1 (###) ###-####'"
                                                    v-model="form.phone"
                                                >
                                                <FormError :error="errors[0]"  name="Phone"></FormError>
                                            </label>

                                        </ValidationProvider>

                                        <ValidationProvider
                                            class="col-sm-6"
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="Role"
                                        >
                                            <label class="form-group">
                                                <span class="form-label">Role*</span>
                                                <select class="custom-select" v-model="form.type">
                                                    <option :value="null">Select One</option>
                                                    <option
                                                        v-for="(role, index) in listOfRoles"
                                                        :key="index"
                                                        :value="role"
                                                    >
                                                        {{ role }}
                                                    </option>
                                                </select>
                                                <FormError :error="errors[0]" name="Role"></FormError>
                                            </label>
                                        </ValidationProvider>

                                        <ValidationProvider
                                            class="col-sm-6"
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="Status"
                                        >
                                            <label class="form-group">
                                                <span class="form-label">Status*</span>
                                                <select class="custom-select" v-model="form.isActive">
                                                    <option :value="null">Select One</option>
                                                    <option :value="1">Active</option>
                                                    <option :value="0">Inactive</option>
                                                </select>
                                                <FormError :error="errors[0]" name="Status"></FormError>
                                            </label>
                                        </ValidationProvider>

                                        <ValidationProvider
                                            class="col-sm-6"
                                            name="password"
                                            v-slot="{ errors }"
                                            rules="min:8|max:20|password_strength|required"
                                        >
                                            <label class="form-group">
                                                <span class="form-label">Password*</span>
                                                <input
                                                    type="text"
                                                    v-model="form.password"
                                                    class="form-control"
                                                    placeholder="Enter your password"
                                                >
                                                <FormError :error="errors[0]" style="color: red; font-size: 10px"  name="password"></FormError>
                                            </label>

                                        </ValidationProvider>

                                        <ValidationProvider
                                            class="col-sm-6"
                                            name="Password"
                                            rules="confirmed:password"
                                            v-slot="{ errors }"
                                        >
                                            <label class="form-group">
                                                <span class="form-label">Confirm Password*</span>
                                                <input
                                                    type="password"
                                                    v-model="form.password_confirmation"
                                                    class="form-control"
                                                    data-vv-as="password"
                                                >
                                                <FormError :error="errors[0]" name="Password"></FormError>
                                            </label>
                                        </ValidationProvider>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group text-center text-md-left m-0">
                                                <button
                                                    type="reset"
                                                    class="btn btn_primary-outline pl-5 pr-5"
                                                    @click="backToPreviousPage"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group text-center text-md-left mt-3 mb-3 m-md-0">
                                                <button type="reset" class="btn btn_delete">DELETE</button>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group text-center text-md-right m-0">
                                                <button
                                                    type="submit"
                                                    class="btn btn_golden"
                                                    @click="validateForm"
                                                >
                                                    <span class="pl-5 pr-5">Save</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import CoverUploader from "../Common/CoverUploader.vue";
import FormError from "../Common/FormError.vue";
import BaseButtons from "../Common/BaseButtons.vue";
import ModalHandler from "../../mixins/ModalHandler";
import {mapActions, mapState} from "pinia";
import {useAdminStore} from "../../stores/AdminStore";
import AdminService from "../../services/AdminService";

export default defineComponent({
    name: "UserEditor",
    components: {BaseButtons, FormError, CoverUploader},
    mixins: [ModalHandler],
    props: {
        userId: Number
    },
    data() {
        return {
            passwordError: null,
            avatarFile: null,
            form: {
                first_name: null,
                last_name: null,
                isActive: true,
                avatar: null,
                email: null,
                phone: null,
                password: null,
                password_confirmation: null,
                type: null,
                status: null,
            }
        }
    },
    computed: {
        ...mapState(useAdminStore, {
            listOfRoles: 'roles'
        })
    },
    mounted() {
        this.getListOfRoles()
        if( this.userId) {
            this.getUserInfo()
        }
    },
    methods: {
        ...mapActions(useAdminStore, {
            getListOfRoles: 'fetchListOfRoles'
        }),
        updateUserAvatar(result) {
            this.avatarFile = result
            this.form.avatar = result.id
        },
        async validateForm() {
            const valid = await this.$refs.form.validate()
            if (!valid) {
                this.$showValidationErrorMessage()
                return
            }
            await this.saveUserInfo()
        },
        async saveUserInfo() {
            this.$showLoadingMessage()
            const uploadMethod = this.userId
                ? AdminService.updateUserInfo(this.userId, this.form)
                : AdminService.createNewUser(this.form);

            try {
                await uploadMethod
                this.$showSuccessMessage("The user details was saved");
                window.location.href = '/admin/users'
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The user info was not saved, please try again')
            }
        },
        async getUserInfo() {
            try {
                const {data: response} = await AdminService.getUserInfo(this.userId);
                this.form = response
                if(response.avatar) {
                    this.avatarFile = response.avatar
                    this.form.avatar = response.avatar.id
                }
            } catch {
                console.error()
            }
        },
    }
})
</script>



<style scoped>

</style>
